/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "apunte-digital";
export const APP_DOMAIN = "app.apunte-digital.com";

/**
 * SOFT_DELETE_STANDARD — days a page remains in the trash before the server purge
 * job physically deletes it (the same value as `TRASH_PURGE_DAYS` in the server
 * environment; a client constant for the "will be deleted in Y days" countdown in
 * the trash UX).
 */
export const TRASH_PURGE_DAYS = 30;
